export default {
  data() {
    return {
      validacaoId: "servicosPrestados",
      errorsServicos: {
        campoOutrosServicos: "",
        campoOutrosExamesLaboratorio: "",
        campoOutrosExamesCentroDiagnostico: "",
        campoOutrosExamesPostoColeta: "",
        campoOutrosHemodinamica: "",
        campoOutrosHemodialise: "",
        campoOutrosOncologia: "",
        campoOutrosCentroMultiprofissionalMultidisciplinar: "",
        campoOutrosCentroMultiprofissionalViverBem: "",
        campoOutrosOutros: ""
      },
      mensagemDeErroServicos: {
        servicos: "",
        outrosExamesLaboratorio: "",
        outrosExamesCentroDiagnostico: "",
        outrosExamesPostoColeta: "",
        outrosHemodinamica: "",
        outrosHemodialise: "",
        outrosOncologia: "",
        outrosCentroMultiprofissionalMultidisciplinar: "",
        outrosCentroMultiprofissionalViverBem: "",
        outrosOutros: ""
      }
    };
  },
  methods: {
    checkoutCompletoErrors() {
      let temErro = false;
      Object.values(this.errorsServicos).forEach(err => {
        if (err.length > 0) {
          temErro = true;
        }
      });
      Object.values(this.mensagemDeErroServicos).forEach(err => {
        if (err.length > 0) {
          temErro = true;
        }
      });
      return temErro;
    }
  },
  computed: {
    temErrors() {
      let temErro = false;
      Object.values(this.errorsServicos).forEach(err => {
        if (err.length > 0) {
          temErro = true;
        }
      });
      Object.values(this.mensagemDeErroServicos).forEach(err => {
        if (err.length > 0) {
          temErro = true;
        }
      });
      return temErro;
    }
  },
  watch: {
    temErrors(boo) {
      const payload = {
        temErro: boo,
        validacaoId: this.validacaoId
      };
      this.$emit("error", payload);
    },
    campoOutros: function(novoValor) {
      if (!novoValor) return;

      if (
        novoValor.length > 0 ||
        (novoValor.length == 0 && this.servicos.length == 0)
      ) {
        this.errorsServicos.campoOutrosServicos = "";
      } else {
        this.errorsServicos.campoOutrosServicos = "Este campo é Obrigatório!";
      }
    }
  }
};
